import { useState } from "react";
import ImageLightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import socialImage1 from "../images/social/ig-social-1.webp";
import socialImage2 from "../images/social/ig-social-2.webp";
import socialImage3 from "../images/social/ig-social-3.webp";
import socialImage4 from "../images/social/ig-social-4.webp";
import socialImage5 from "../images/social/ig-social-5.webp";
import socialImage6 from "../images/social/ig-social-6.jpg"
import socialImage7 from "../images/social/ig-social-7.webp";
import socialImage8 from "../images/social/ig-social-8.webp";
import socialImage9 from "../images/social/ig-social-9.jpg"
import socialImage10 from "../images/social/ig-social-10.jpg"
import socialImage11 from "../images/social/ig-social-11.jpg"
import socialImage12 from "../images/social/ig-social-12.jpg"
import socialImage13 from "../images/social/ig-social-13.jpg"
import socialImage14 from "../images/social/ig-social-14.jpg"
import socialImage15 from "../images/social/ig-social-15.jpg"
import socialImage16 from "../images/social/ig-social-16.jpg"
import socialImage17 from "../images/social/ig-social-17.jpg"
import socialImage19 from "../images/social/ig-social-19.jpg"

const Gallery = () => {
  const galleryImages = [
    socialImage1,
    socialImage2,
    socialImage3,
    socialImage4,
    socialImage5,
    socialImage6,
    socialImage7,
    socialImage8,
    socialImage9,
    socialImage10,
    socialImage11,
    socialImage12,
    socialImage13,
    socialImage14,
    socialImage15,
    socialImage16,
    socialImage17,
    socialImage19,
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openLightBox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  const closeLightBox = () => {
    setIsOpen(false);
  };

  const goToPrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
  };

  return (
    <section id="gallery">
      <div className="container p-5">
        <div className="pb-5">
          <div className="d-flex flex-column section-header py-5">
            <h2 className="fw-bold">Gallery</h2>
            <p className="text-decoration-underline">A little insight into what we do</p>
          </div>
          <div className="gallery-container pb-5">
            {galleryImages.map((image, index) => (
              <div
                className="gallery-item"
                key={index}
                onClick={() => openLightBox(index)}
              >
                <img
                  src={image}
                  alt={`Gallery - ${index}`}
                  className="gallery-image"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {isOpen && (
        <ImageLightbox
          mainSrc={galleryImages[currentImageIndex]}
          nextSrc={
            galleryImages[(currentImageIndex + 1) % galleryImages.length]
          }
          prevSrc={
            galleryImages[
              (currentImageIndex - 1 + galleryImages.length) %
                galleryImages.length
            ]
          }
          onCloseRequest={closeLightBox}
          onMovePrevRequest={goToPrevious}
          onMoveNextRequest={goToNext}
          enableZoom={true}
        />
      )}

      <div className="light-to-dark-fade-out"></div>
    </section>
  );
};

export default Gallery;
